<button>
  <yoo-icon [icon]="icon" [size]="iconSize"></yoo-icon>
</button>